import { observable, action, computed, configure, runInAction } from 'mobx';
import { createContext, SyntheticEvent } from 'react';
import { IProject as IProject } from '../models/project';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { IProjectNote } from '../models/projectnote';
import { IProjectScope } from '../models/projectscope';
import { IProjectLog } from '../models/projectlog';
import {IProjectVendor} from '../models/projectvendor';
import { IThirdparty } from '../models/thirdparty';
import { IAssign } from '../models/assign';
import { IProjectPermit } from '../models/projectpermit';
import { stringify } from 'querystring';
import { IProjectBog } from '../models/projectbog';
import { IProjectDocument } from '../models/projectdocument';

configure({enforceActions: 'always'});

class MobileStore {

  @observable projectRegistry = new Map();
  @observable projectSearchRegistry = new Map();
  @observable project: IProject | null = null;
  @observable projectnotes: IProjectNote[]  = [];
  @observable projectnote: IProjectNote | null = null;
  @observable projectscopes: IProjectScope[]  = [];
  @observable projectlogRegistry = new Map();
  @observable customerRegistry = new Map();
  @observable projectvendorRegistry = new Map();
  @observable projectvendor: IProjectVendor | null = null;
  @observable selectedProjectVendor: IProjectVendor | undefined;
  @observable thirdRegistry = new Map();
  @observable thirdparty: IThirdparty | null = null;
  @observable technicianRegistry = new Map();
  @observable technicianallRegistry = new Map();
  @observable assign: IAssign[] | null = null;
  @observable techzoneRegistry = new Map();
  @observable techworkRegistry = new Map();
  @observable techgpsRegistry = new Map();
  @observable techacRegistry = new Map();
  @observable techinductionRegistry = new Map();
  @observable inductionRegistry = new Map();
  @observable projectpermitRegistry = new Map();
  @observable projectaccessRegistry = new Map();
  @observable projectbogRegistry = new Map();
  @observable projectdocumentRegistry = new Map();
  @observable activeDetailTab: number = 0;
  @observable activeListTab: number = 0;
  @observable loadingInitial = false;
  @observable submitting = false;
  @observable editMode = false;
  @observable target = '';


  @computed get projectsByDate() {
    return Array.from(this.projectSearchRegistry.values()).sort(
      (a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt)
    );
  }

  @computed get projectnotesByDate() {
    return this.projectnotes.sort(
      (a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt)
    );
  }

  @computed get customersByName() {
    return Array.from(this.customerRegistry.values()).sort(
      (a, b) => a.name.localeCompare(b.name))
    ;
  }

  @computed get projectlogsByDate() {
    return Array.from(this.projectlogRegistry.values()).sort(
      (a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt)
    );
  }

  @computed get projectvendorsByName() {
    return Array.from(this.projectvendorRegistry.values()).sort(
      (a, b) => a.companyName.localeCompare(b.companyName));
  }

  @computed get ThirdPartiesByName() {
    return Array.from(this.thirdRegistry.values()).sort(
      (a, b) => a.companyName.localeCompare(b.companyName));
  }

  @computed get TechzoneByName() {
    return Array.from(this.techzoneRegistry.values()).sort(
      (a, b) => a.name.localeCompare(b.name));
  }

  @computed get TechWorkByName() {
    return Array.from(this.techworkRegistry.values()).sort(
      (a, b) => a.name.localeCompare(b.name));
  }

  @computed get TechGPSByName() {
    return Array.from(this.techgpsRegistry.values()).sort(
      (a, b) => a.name.localeCompare(b.name));
  }

  @computed get TechACByName() {
    return Array.from(this.techacRegistry.values()).sort(
      (a, b) => a.name.localeCompare(b.name));
  }

  @computed get TechInduction() {
    return Array.from(this.inductionRegistry.values());
  }

  @computed get projectpermitsByTime() {
    return Array.from(this.projectpermitRegistry.values()).sort(
      (a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt)
    )
  }

  @computed get projectaccessByTime() {
    return Array.from(this.projectaccessRegistry.values()).sort(
      (a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt)
    )
  }

  @computed get projectbogsByTime() {
    return Array.from(this.projectbogRegistry.values()).sort(
      (a, b) => Date.parse(a.bogDate) - Date.parse(b.bogDate)
    )
  }

  @computed get techniciansByName() {
    return Array.from(this.technicianRegistry.values()).sort(
      (a, b) => a.name.localeCompare(b.name))
    ;
  }

  @computed get projectPOsByName() {
    return Array.from(this.projectdocumentRegistry.values()).filter((doc) =>
    doc.category === 'PO');
  }

  @computed get projectMaterialsByName() {
    return Array.from(this.projectdocumentRegistry.values()).filter((doc) =>
    doc.category === 'Material');
  }

  @computed get projectVariationsByName() {
    return Array.from(this.projectdocumentRegistry.values()).filter((doc) =>
    doc.category === 'Variation');
  }

  @computed get projectArtifactsByName() {
    return Array.from(this.projectdocumentRegistry.values()).filter((doc) =>
    doc.category === 'Artifacts');
  }

  @action loadProjects = async (type: string, status: string) => {
    this.loadingInitial = true;
    try {
      const projects = await agent.Projects.list(type, status);
      runInAction('loading projects', () => {
        this.projectRegistry.clear();
        this.projectSearchRegistry.clear();
        projects.forEach(project => {
          (project.receiveDate) ? project.receiveDate = project.receiveDate.substr(0,10) : project.receiveDate = "";
          (project.requireDate) ? project.requireDate = project.requireDate.substr(0,10) : project.requireDate = "";
         (project.jobStartDate) ? project.jobStartDate = project.jobStartDate.substr(0,10) : project.jobStartDate = "";
         (project.estimatedCompletionDate) ? project.estimatedCompletionDate = project.estimatedCompletionDate.substr(0,10) : project.estimatedCompletionDate = "";
          this.projectRegistry.set(project.id, project);
          this.projectSearchRegistry.set(project.id, project);
        });
        this.loadingInitial = false;
        
      })

    } catch (error) {
      runInAction('load projects error', () => {
        this.loadingInitial = false;
      })
      toast.error('load projects error');
    }
  };

  @action loadProject = async (id: string) => {
    let project = this.getProject(id);
    if (project) {
      this.project = project;
    } else {
      this.loadingInitial = true;
       try {
         project = await agent.Projects.details(id);
         runInAction('getting project',() => {
           this.project = project;
           this.loadingInitial = false;
         })
       } catch (error) {
         runInAction('get project error', () => {
           this.loadingInitial = false;
         })
         toast.error('get project error');
         console.log(error);
       }
    }
  };

  @action clearProject = () => {
    this.project = null;
  }

  getProject = (id: string) => {
    return this.projectRegistry.get(Number(id));
  }


  @action createProject = async (project: IProject) => {
    this.submitting = true;
    try {
     
      project.createdAt = new Date().toJSON();
      project.updatedAt = new Date().toJSON();

      await agent.Projects.create(project);
      runInAction('create project', () => {
        // this.projectRegistry.set(project.id, project);
        this.submitting = false;
      })
    } catch (error) {
      runInAction('create project error', () => {
        this.submitting = false;
      })
      toast.error('create project error');
      console.log(error);
    }
  };

  @action editProject = async (project: IProject) => {
    this.submitting = true;
    try {
     // project.updatedAt = new Date().toJSON();
      await agent.Projects.update(project);
      runInAction('editing project', () => {
        this.projectRegistry.set(project.id, project);
        this.projectSearchRegistry.set(project.id, project);
        this.project = project;
        this.submitting = false;
      })

    } catch (error) {
      runInAction('edit project error', () => {
        this.submitting = false;
      })
      toast.error('edit project error');
      console.log(error);
    }
  };

  @action deleteProject = async (id: string) => {
    this.submitting = true;
    this.target = id;
    try {
      await agent.Projects.delete(id);
      runInAction('deleting project', () => {
        this.projectRegistry.delete(id);
        this.projectSearchRegistry.delete(id);
        this.submitting = false;
        this.target = '';
      })
    } catch (error) {
      runInAction('delete project error', () => {
        this.submitting = false;
        this.target = '';
      })
      toast.error('delete project error');
      console.log(error);
    }
  }

  @action generate = async () => {
    let code = "";
    try {
      var project = await agent.Projects.generate();
      code = project.projectCode;
      runInAction("getting code", () => {
        return code;
      });
    } catch (error) {
      runInAction("get code error", () => {});
      toast.error("get code error");
      console.log(error);
    }
    return code;
  };

  @action searchTechnician = async (term: string) => {
    let technicians = Array.from(this.technicianRegistry.values());
    if (term) {
      const selectedTechnicians = technicians.filter((tech) =>
        tech.name.toLowerCase().includes(term.toLowerCase()) || 
        tech.preferredName.toLowerCase().includes(term.toLowerCase())
      );
      this.techzoneRegistry.clear();
      selectedTechnicians.forEach((tech) => {
          this.techzoneRegistry.set(tech.email, tech);
        });
    } else {
      technicians.forEach((tech) => {
        this.techzoneRegistry.set(tech.email, tech);
      });
    }
};

  //Project Notes
  @action loadProjectNotes = async (projectId: string) => {
    // this.loadingInitial = true;
    try {
      this.projectnotes.length = 0;
      const projectnotes = await agent.ProjectNotes.list(projectId);
      runInAction('loading tasks', () => {
        projectnotes.forEach(projectnote => {
          this.projectnotes.push(projectnote);
        });
      // this.loadingInitial = false;
       })
  
    } catch (error) {
      runInAction('load project notes error', () => {
        // this.loadingInitial = false;
      })
      toast.error('load project notes error');
    }
  };
  
  @action createProjectNote = async (projectnote: IProjectNote) => {
    this.submitting = true;
    try {
      const note = await agent.ProjectNotes.create(projectnote);
      runInAction('create project note', () => {
        // this.projectnoteRegistry.set(projectnote.id, projectnote);
        this.projectnotes.push(note);
        this.submitting = false;
      })
    } catch (error) {
      runInAction('create project note error', () => {
        this.submitting = false;
      })
      toast.error('create project note error');
      console.log(error);
    }
  };
  
  @action deleteProjectNote = async (note: IProjectNote) => {
    try {
      await agent.ProjectNotes.delete(note.id);
      runInAction('deleting project note', () => {
        let index = this.projectnotes.indexOf(note);
        if (index !== -1) {
          this.projectnotes.splice(index, 1);
        }
        this.target = '';
      })
    } catch (error) {
      runInAction('delete project note error', () => {
        this.target = '';
      })
      toast.error('delete project note error');
      console.log(error);
    }
  }

  @action updateProjectNote = async (id: string, status: string) => {
    this.submitting = true;
    try {
      const note = await agent.ProjectNotes.update(id, status);
      runInAction('create project note', () => {
        let objIndex = this.projectnotes.findIndex((obj => obj.id == id));
        this.projectnotes[objIndex].status = status;
        this.submitting = false;
      })
    } catch (error) {
      runInAction('create project note error', () => {
        this.submitting = false;
      })
      toast.error('create project note error');
      console.log(error);
    }
  };

  @action loadProjectScopes = async (projectId: string) => {
    // this.loadingInitial = true;
    try {
      this.projectscopes.length = 0;
      const projectscopes = await agent.ProjectScopes.list(projectId);
      runInAction('loading tasks', () => {
        projectscopes.forEach(projectscope => {
          this.projectscopes.push(projectscope);
        });
      // this.loadingInitial = false;
       })
  
    } catch (error) {
      runInAction('load project notes error', () => {
        // this.loadingInitial = false;
      })
      toast.error('load project notes error');
    }
  };

  @action createProjectScope = async (projectscope: IProjectScope) => {
    this.submitting = true;
    projectscope.createdAt = new Date().toJSON();
    projectscope.updatedAt = new Date().toJSON();
    try {
      await agent.ProjectScopes.create(projectscope);
      runInAction('create project scope', () => {
        this.projectscopes.push(projectscope);
        this.project!.status = "Orders Not Yet Accepted";
        this.submitting = false;
      })
    } catch (error) {
      runInAction('create project scope error', () => {
        this.submitting = false;
      })
      toast.error('create project scope error');
      console.log(error);
    }
  };

  //Project Log Tab
  @action loadProjectLogs = async (projectId: string) => {
    try {
      const projectlogs = await agent.ProjectLogs.list(projectId);
      this.projectlogRegistry.clear();
      runInAction('loading tasks', () => {
        projectlogs.forEach(projectlog => {
          this.projectlogRegistry.set(projectlog.id, projectlog);
        });
      })
  
    } catch (error) {
      runInAction('load tasks error', () => {
      })
      toast.error('load tasks error');
    }
  };
  
  @action createProjectLog = async (projectlog: IProjectLog) => {
    this.submitting = true;
    try {
     projectlog.createdAt = new Date().toJSON();
     projectlog.updatedAt = new Date().toJSON();
  
      await agent.ProjectLogs.create(projectlog);
      runInAction('create project log', () => {
        this.submitting = false;
      })
    } catch (error) {
      runInAction('create project log error', () => {
        this.submitting = false;
      })
      toast.error('create project log error');
      console.log(error);
    }
  };
  
  @action deleteProjectLog = async (event: SyntheticEvent<HTMLButtonElement>, id: string) => {
    this.target = event.currentTarget.name;
    try {
      await agent.ProjectLogs.delete(id);
      runInAction('deleting project', () => {
        this.projectlogRegistry.delete(id);
        this.target = '';
      })
    } catch (error) {
      runInAction('delete project error', () => {
        this.target = '';
      })
      toast.error('delete project error');
      console.log(error);
    }
  }

  @action loadCustomers = async () => {
    this.loadingInitial = true;
    try {
      const customers = await agent.Customers.list();
      runInAction("loading customers", () => {
        customers.forEach((customer) =>
          this.customerRegistry.set(customer.id, customer)
        );
        this.loadingInitial = false;
      });
    } catch (error) {
      runInAction("load Customer List Error", () => {
        this.loadingInitial = false;
      });
      toast.error("load Customer List Error");
    }
  };

  //Third party
  @action loadProjectVendors = async (projectId: string) => {
    // this.loadingInitial = true;
    try {
      const projectvendors = await agent.ProjectVendors.list(projectId);
      this.projectvendorRegistry.clear();
      runInAction('loading vendors', () => {
        projectvendors.forEach(projectvendor => {
         if (projectvendor.type === 'Vendor') this.projectvendorRegistry.set(projectvendor.id, projectvendor);
         if (projectvendor.type === 'Access') this.projectaccessRegistry.set(projectvendor.id, projectvendor);
        });
        // this.loadingInitial = false;
      })
  
    } catch (error) {
      runInAction('load vendors error', () => {
        // this.loadingInitial = false;
      })
    }
  }
  
  @action createProjectVendor = async (projectvendor: IProjectVendor) => {
    this.submitting = true;
    try {
      await agent.ProjectVendors.create(projectvendor);
      runInAction('create project vendor', () => {
        this.submitting = false;
      })
    } catch (error) {
      runInAction('create project vendor error', () => {
        this.submitting = false;
      })
      console.log(error);
    }
  };
  
  @action deleteProjectVendor = async (event: SyntheticEvent<HTMLButtonElement>, id: string) => {
    this.submitting = true;
    this.target = event.currentTarget.name;
    try {
      await agent.ProjectVendors.delete(id);
      runInAction('deleting project vendor', () => {
        this.projectvendorRegistry.delete(id);
        this.submitting = false;
        this.target = '';
      })
    } catch (error) {
      runInAction('delete project vendor error', () => {
        this.submitting = false;
        this.target = '';
      })
      console.log(error);
    }
  }
  
  @action editProjectVendor = async (projectvendor: IProjectVendor) => {
    this.submitting = true;
    try {
      await agent.ProjectVendors.update(projectvendor);
      runInAction('editing project vendor', () => {
        this.projectvendorRegistry.set(projectvendor.id, projectvendor);
        this.projectvendor = projectvendor;
        this.editMode = false;
        this.submitting = false;
      })
  
    } catch (error) {
      runInAction('edit project error', () => {
        this.submitting = false;
      })
      console.log(error);
    }
  };
  
  @action selectProjectVendor = (id: string) => {
    this.selectedProjectVendor = this.projectvendorRegistry.get(id);
    this.editMode = true;
  };
  
  @action loadThirdParties = async () => {
    // this.loadingInitial = true;
    try {
      const thirdparties = await agent.ThirdParties.list();
      this.thirdRegistry.clear();
      runInAction('loading ThirdParties', () => {
        thirdparties.forEach(thirdparty => {
          this.thirdRegistry.set(thirdparty.companyName, thirdparty);
        });
        // this.loadingInitial = false;
      })
  
    } catch (error) {
      runInAction('load ThirdParties List error', () => {
        // this.loadingInitial = false;
      })
    }
  };

  @action cancelFormOpen = () => {
    this.editMode = false;
  }

  @action loadTechnicians = async () => {
    try {
      const employees = await agent.Employees.list();
      runInAction("loading empolyees", () => {
        this.technicianRegistry.clear();
        this.technicianallRegistry.clear();
        this.techzoneRegistry.clear();
        employees.forEach((employee) => {
          this.technicianallRegistry.set(employee.email, employee);
          if ((employee.status === 'Subcontractor' || employee.status === 'Employee') && 
          employee.projectType.includes('Mobile')) 
          {
            this.technicianRegistry.set(employee.email, employee);
            this.techzoneRegistry.set(employee.email, employee);
            this.techinductionRegistry.set(employee.email, 'N');
          }
        });
      });
    } catch (error) {
      runInAction("load technician Error", () => {
      });
      toast.error("load technician Error");
    }
  };

  //Assignment tab
  @action AssignTechnicians = async (source: string, dest: string, email: string) => {
    const tech = this.technicianallRegistry.get(email);
    if (dest === "TechZone")
    {
      if (source === "TechWork") this.techworkRegistry.delete(email);
      if (source === "GPS") this.techgpsRegistry.delete(email);
      if (source === "AC") this.techacRegistry.delete(email);
      if (!this.techworkRegistry.has(email) && !this.techgpsRegistry.has(email) && !this.techacRegistry.has(email))
        this.inductionRegistry.delete(email);
    }
    else if (dest === "TechWork")
    {
      this.techworkRegistry.set(email, tech);
      this.inductionRegistry.set(email, {email: email, induction: 'N'});
    }
    else if (dest === "GPS")
    {
      this.techgpsRegistry.set(email, tech);
      this.inductionRegistry.set(email, {email: email, induction: 'N'});
    }
    else if (dest === "AC")
    {
      this.techacRegistry.set(email, tech);
      this.inductionRegistry.set(email, {email: email, induction: 'N'});
    }
  };

  @action createMobileAssignment = async (projectId: string, assigments: IAssign[]) => {
    this.submitting = true;
    const mobileAssignment = [];
    for (let i = 0; i < assigments.length; i++)
    {
      const assign = {
        item: assigments[i].item,
        manday: assigments[i].manday,
        remark: assigments[i].remark,
        tech: [] as any,
      }
      if (assigments[i].item === 'TechWork')
      {
        Array.from(this.techworkRegistry.keys()).forEach((email) => {
          assign.tech.push({email: email, induction: 'N'});
        })
      }
      else if (assigments[i].item === 'GPS')
      {
        Array.from(this.techgpsRegistry.keys()).forEach((email) => {
          assign.tech.push({email: email, induction: 'N'});
        })
      }
      else if (assigments[i].item === 'AC')
      {
        Array.from(this.techacRegistry.keys()).forEach((email) => {
          assign.tech.push({email: email, induction: 'N'});
        })
      }
      mobileAssignment.push(assign);

    }
    console.log(mobileAssignment);
    try {
      await agent.MobileAssignments.create(projectId, mobileAssignment);
      runInAction('create mobile assignment', () => {
        this.submitting = false;
      })
      toast.success('create assignment success');
    } catch (error) {
      runInAction('create mobile assignment error', () => {
        this.submitting = false;
      })
      toast.error('create assignment error');
      console.log(error);
    }
  };

  @action loadMobileAssignments = async (projectId: string) => {
    let assign : IAssign[] = [
      {
        item: "TechWork",
        manday: "0",
        remark: "",
      },
      {
        item: "GPS",
        manday: "0",
        remark: "",
      },
      {
        item: "AC",
        manday: "0",
        remark: "",
      }];

    try {
      const mobileassignments = await agent.MobileAssignments.list(projectId);
      this.techworkRegistry.clear();
      this.techgpsRegistry.clear();
      this.techacRegistry.clear();
      this.techinductionRegistry.clear();
      this.inductionRegistry.clear();
      runInAction('loading tasks', () => {
        mobileassignments.forEach((mobileassignment: any) => {
          if (mobileassignment.item === 'TechWork')
          {
            assign[0].manday = mobileassignment.manday;
            assign[0].remark = mobileassignment.remark;
            mobileassignment.tech.forEach((te: any) => {
              if (this.technicianallRegistry.get(te.email))
              {
               let tech = this.technicianallRegistry.get(te.email);
               this.techworkRegistry.set(te.email, tech);
               this.techinductionRegistry.set(te.email, te.induction);
               this.inductionRegistry.set(te.email, {email: te.email, induction: te.induction});
              }
            })
          }
          else if (mobileassignment.item === 'GPS')
          {
            assign[1].manday = mobileassignment.manday;
            assign[1].remark = mobileassignment.remark;
            mobileassignment.tech.forEach((te: any) => {
              if (this.technicianallRegistry.get(te.email))
              {
               let tech = this.technicianallRegistry.get(te.email);
               this.techgpsRegistry.set(te.email, tech);
               this.techinductionRegistry.set(te.email, te.induction);
               this.inductionRegistry.set(te.email, {email: te.email, induction: te.induction});
              }
            })
          }
          else if (mobileassignment.item === 'AC')
          {
            assign[2].manday = mobileassignment.manday;
            assign[2].remark = mobileassignment.remark;
            mobileassignment.tech.forEach((te: any) => {
              if (this.technicianallRegistry.get(te.email))
              {
               let tech = this.technicianallRegistry.get(te.email);
               this.techacRegistry.set(te.email, tech);
               this.techinductionRegistry.set(te.email, te.induction);
               this.inductionRegistry.set(te.email, {email: te.email, induction: te.induction});
              }
            })
          }

        });
        this.assign = assign;
     //   return assign;
      })
  
    } catch (error) {
      runInAction('load tasks error', () => {
      })
      toast.error('load tasks error');
    }
  //  return assign;
  };

  //Permit
  @action loadProjectPermits = async (projectId: string) => {
    try {
      const projectpermits = await agent.ProjectPermits.list(projectId);
      this.projectpermitRegistry.clear();
      runInAction('loading tasks', () => {
        if (projectpermits.length === 0)
        {
          this.projectpermitRegistry.set('new', {createdAt: new Date().toISOString(), code: 'new'});
        }
        else
        {
          projectpermits.forEach(projectpermit => {
            this.projectpermitRegistry.set(projectpermit.id, projectpermit);
          });
        }
      })
  
    } catch (error) {
      runInAction('load permits error', () => {
      })
      toast.error('load permits error');
    }
  };
  
  @action createProjectPermit = async (projectpermit: IProjectPermit) => {
    this.submitting = true;
    try {
      if (this.project!.workType === 'TPG') projectpermit.code = 'CR' + projectpermit.code; 
      if (this.project!.workType === 'OPTUS') projectpermit.code = 'PTW' + projectpermit.code;
      const permit = await agent.ProjectPermits.create(projectpermit);
      runInAction('create project permit', () => {
        this.projectpermitRegistry.delete('new');
        this.projectpermitRegistry.set(permit.id, permit);
        this.submitting = false;
      })
    } catch (error) {
      runInAction('create project permit error', () => {
        this.submitting = false;
      })
      toast.error('create project permit error');
      console.log(error);
    }
  };
  
  @action deleteProjectPermit = async (id: string) => {
    try {
      await agent.ProjectPermits.delete(id);
      runInAction('deleting project permit', () => {
        this.projectpermitRegistry.delete(id);
      })
    } catch (error) {
      runInAction('delete project permit error', () => {
      })
      toast.error('delete project permit error');
      console.log(error);
    }
  }

  @action addProjectPermit = async () => {
    this.projectpermitRegistry.set('new', {createdAt: new Date().toISOString(), code: 'new'});
  }

  //Select
  @action selectMobileTitle = async (title: string, text: string) => {
    let projects = Array.from(this.projectRegistry.values());
    if (text !== 'ALL') {
      let selectedProjects = [];
      if (title === 'workType')
      {
        selectedProjects = projects.filter((project) =>
        project.workType.toLowerCase() === text.toLowerCase()
        );
      }
      else if (title === 'customerId')
      {
        selectedProjects = projects.filter((project) =>
        project.customerId === text
        );
      }
      else if (title === 'category')
      {
        selectedProjects = projects.filter((project) =>
        project.category.toLowerCase() === text.toLowerCase()
        );
      }
      this.projectSearchRegistry.clear();
         selectedProjects.forEach((project) => {
          this.projectSearchRegistry.set(project.id, project);
        });
    } else {
      this.projectSearchRegistry.clear();
      projects.forEach((project) => {
        this.projectSearchRegistry.set(project.id, project);
      });
    }
  };

  //Access
  @action loadProjectAccess = async () => {
        if (this.projectaccessRegistry.size === 0)
        {
          this.projectaccessRegistry.set('new', {createdAt: new Date().toISOString(), type: 'new'});
        }
  };
  
  @action createProjectAccess = async (projectaccess: IProjectVendor) => {
    this.submitting = true;
    try {
      const access = await agent.ProjectVendors.create(projectaccess);
      runInAction('create project access', () => {
        this.projectaccessRegistry.delete('new');
        this.projectaccessRegistry.set(access.id, access);
        this.submitting = false;
      })
    } catch (error) {
      runInAction('create project access error', () => {
        this.submitting = false;
      })
      toast.error('create project access error');
      console.log(error);
    }
  };
  
  @action deleteProjectAccess = async (id: string) => {
    try {
      await agent.ProjectVendors.delete(id);
      runInAction('deleting project access', () => {
        this.projectaccessRegistry.delete(id);
      })
    } catch (error) {
      runInAction('delete project access error', () => {
      })
      toast.error('delete project access error');
      console.log(error);
    }
  }

  @action addProjectAccess = async () => {
    this.projectaccessRegistry.set('new', {createdAt: new Date().toISOString(), type: 'new'});
  }

  @action editTechnicianInduction = async (projectId: string, email: string, status: string) => {
    this.submitting = true;
    try {
     // project.updatedAt = new Date().toJSON();
      await agent.TaskAssignments.updateInduction(projectId, email, status);
      runInAction('editing project', () => {
        this.inductionRegistry.set(email, {email: email, induction: status});
        this.techinductionRegistry.set(email, status);
        this.submitting = false;
      })

    } catch (error) {
      runInAction('edit project error', () => {
        this.submitting = false;
      })
      toast.error('edit project error');
      console.log(error);
    }
  };

  @action updateProjectAccessStatus = async (status: string, projectVendor: IProjectVendor) => {
    this.submitting = true;
    const projectvendor: IProjectVendor = {
      id: projectVendor.id,
      createdAt: "",
      updatedAt: "",
      projectId: projectVendor.projectId,
      type: projectVendor.type,
      companyName: projectVendor.companyName,
      status: status,
      attachment: projectVendor.attachment,
      remark: projectVendor.remark,
      phone: projectVendor.phone,
      email: projectVendor.email,
    }
    try {
      await agent.ProjectVendors.update(projectvendor);
      runInAction('editing project', () => {
        this.projectaccessRegistry.set(projectvendor.id, projectvendor);
        this.submitting = false;
      })

    } catch (error) {
      runInAction('edit project error', () => {
        this.submitting = false;
      })
      toast.error('edit project error');
      console.log(error);
    }
  };

  //BOG
  @action loadProjectBogs = async (projectId: string) => {
    try {
      const projectbogs = await agent.ProjectBogs.list(projectId);
      this.projectbogRegistry.clear();
      runInAction('loading bogs', () => {
        if (projectbogs.length === 0)
        {
          this.projectbogRegistry.set('new', {createdAt: new Date().toISOString(), activity: 'new'});
        }
        else
        {
          projectbogs.forEach(projectbog => {
            projectbog.bogDate = projectbog.bogDate.substr(0,10);
            projectbog.technicianEmail = projectbog.technicianEmail.split(',');
            this.projectbogRegistry.set(projectbog.id, projectbog);
          });
        };
      })
  
    } catch (error) {
      runInAction('load bogs error', () => {
      })
      toast.error('load bogs error');
    }
  };
  
  @action createProjectBog = async (projectbog: IProjectBog) => {
    this.submitting = true;
    projectbog.technicianEmail = projectbog.technicianEmail.toString();
    try {
      const bog = await agent.ProjectBogs.create(projectbog);
      runInAction('create project bog', () => {
        this.projectbogRegistry.delete('new');
        bog.bogDate = bog.bogDate.substr(0,10)
        bog.technicianEmail = bog.technicianEmail.split(',');
        this.projectbogRegistry.set(bog.id, bog);
        this.submitting = false;
      })
    } catch (error) {
      runInAction('create project bog error', () => {
        this.submitting = false;
      })
      toast.error('create project bog error');
      console.log(error);
    }
  };
  
  @action deleteProjectBog = async (id: string) => {
    try {
      await agent.ProjectBogs.delete(id);
      runInAction('deleting project bog', () => {
        this.projectbogRegistry.delete(id);
      })
    } catch (error) {
      runInAction('delete project bog error', () => {
      })
      toast.error('delete project bog error');
      console.log(error);
    }
  }

  @action addProjectBog = async () => {
    this.projectbogRegistry.set('new', {createdAt: new Date().toISOString(), activity: 'new'});
  }

  @action updateBog = async (task : IProjectBog, name: keyof IProjectBog, value: any) => {
    task[name] = value as never;
    this.projectbogRegistry.set(task.id, task);
  };

  @action editProjectBog = async (projectbog: IProjectBog) => {
    this.submitting = true;
    projectbog.technicianEmail = projectbog.technicianEmail.toString();
    try {
      await agent.ProjectBogs.update(projectbog);
      runInAction('editing project', () => {
        projectbog.technicianEmail = projectbog.technicianEmail.split(',');
        this.projectbogRegistry.set(projectbog.id, projectbog);
        this.submitting = false;
      })
      toast.success('Saved successfully');

    } catch (error) {
      runInAction('edit project bog error', () => {
        this.submitting = false;
      })
      toast.error('edit project bog error');
      console.log(error);
    }
  };

  @action searchProject = async (term: string) => {
    let projects = Array.from(this.projectRegistry.values());
    if (term) {
      const selectedProjects = projects.filter((project) =>
        project.siteId.toLowerCase().includes(term.toLowerCase()) || 
        project.siteName.toLowerCase().includes(term.toLowerCase())
      );
      this.projectSearchRegistry.clear();
        selectedProjects.forEach((project) => {
          this.projectSearchRegistry.set(project.id, project);
        });
    } else {
      this.projectSearchRegistry.clear();
      projects.forEach((project) => {
         this.projectSearchRegistry.set(project.id, project);
      });
    }
  };

  //Project Documents
  @action loadProjectDocuments = async (projectId: string) => {
      try {
        const projectdocuments = await agent.ProjectDocuments.list(projectId);
        this.projectdocumentRegistry.clear();
        runInAction('loading documents', () => {
          projectdocuments.forEach(projectdocument => {
            this.projectdocumentRegistry.set(projectdocument.id, projectdocument);
          });
        })
    
      } catch (error) {
        runInAction('load documents error', () => {
        })
        toast.error('load documents error');
      }
  };
    
  @action createProjectDocuments  = async (projectdocuments: IProjectDocument) => {
      this.submitting = true;
      try {
        const docs = await agent.ProjectDocuments.create(projectdocuments);
        runInAction('create documents', () => {
          this.projectdocumentRegistry.set(docs.id, docs);
          this.submitting = false;
        })
      } catch (error) {
        runInAction('create documents error', () => {
          this.submitting = false;
        })
        toast.error('create documents error');
        console.log(error);
      }
  };
    
  @action deleteProjectDocument = async (event: SyntheticEvent<HTMLButtonElement>, id: string) => {
      this.target = event.currentTarget.name;
      try {
        await agent.ProjectDocuments.delete(id);
        runInAction('deleting project', () => {
          this.projectdocumentRegistry.delete(id);
          this.target = '';
        })
      } catch (error) {
        runInAction('delete project error', () => {
          this.target = '';
        })
        toast.error('delete project error');
        console.log(error);
      }
  }

  @action setActiveDetailTab = (activeIndex: number) => {
    this.activeDetailTab = activeIndex;
  } 

  @action setActiveListTab = (activeIndex: number) => {
    this.activeListTab = activeIndex;
  } 

  @action clearPage = () => {
    this.projectlogRegistry.clear();
    this.technicianRegistry.clear();
    this.projectvendorRegistry.clear();
    this.thirdRegistry.clear();
    this.project = null;
    this.projectnotes.length = 0;
    this.projectnote = null;
    this.projectscopes.length = 0;
    this.projectvendor = null;
    this.thirdparty = null;
    this.technicianRegistry.clear();
    this.technicianallRegistry.clear();
    this.techzoneRegistry.clear();
    this.techzoneRegistry.clear();
    this.techgpsRegistry.clear();
    this.techacRegistry.clear();
    this.techinductionRegistry.clear();
    this.inductionRegistry.clear();
    this.projectpermitRegistry.clear();
    this.projectaccessRegistry.clear();
    this.assign = null;
  }

}

export default createContext(new MobileStore());
